module.exports = __webpack_public_path__ + "static/media/bg6.8306f0ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg6.jpg
// module id = 588
// module chunks = 0